export const MIN_AMOUNT = 1
export const MAX_AMOUNT = 10000
